/**
 * Athletes/Caddies don't go through accreditation — same group-name check as ParticipantsList's getOnsiteType.
 * The group picked in Summary wins; the saved group is only used when the pick isn't in the loaded list.
 */
export const isAthleteOrCaddieGroup = ({ participantGroup, groups = [], selectedGroupId }) => {
  const fromHeader = groups.find((g) => String(g._id) === String(selectedGroupId));
  const raw = fromHeader || participantGroup;
  const groupDocs = Array.isArray(raw) ? raw : raw ? [raw] : [];
  const names = groupDocs.map((g) => (typeof g === 'object' ? g?.group_name : '')?.toLowerCase() || '');
  return names.some((n) => n.includes('athlete') || n.includes('caddie'));
};

/**
 * Write Summary values into the live form and re-run its conditions instead of
 * remounting — a remount would drop unsaved edits.
 */
export const syncAssignmentsIntoForm = (webform, liveData, updates) => {
  if (!webform?.data) return;
  Object.assign(webform.data, updates);
  if (liveData && typeof liveData === 'object') Object.assign(liveData, updates);
  webform.triggerChange?.();
};

/** Update the form's invitation type dropdown, not just its data, so the new choice shows on screen. */
export const syncInvitationTypeIntoForm = (webform, liveData, invitationTypeId) => {
  if (!webform?.data || !invitationTypeId) return;
  webform.getComponent?.('invitationTypes')?.setValue(invitationTypeId);
  syncAssignmentsIntoForm(webform, liveData, { invitationTypes: invitationTypeId });
};
